import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { BULK_ID_MODAL_REDUCER_KEY } from '@Pages/Login/BulkIdRegisterModal/constants';
import reducer from '@Pages/Login/BulkIdRegisterModal/reducer';
import { isLoading as isLoadingSelector } from '@Pages/Login/BulkIdRegisterModal/selectors';
import { emailSubmit as emailSubmitAction } from '@Pages/Login/BulkIdRegisterModal/actions';
import ActivatingId from './ActivatingId';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = {
  emailSubmit: emailSubmitAction,
};

export default compose(withReducer(BULK_ID_MODAL_REDUCER_KEY, reducer), connect(mapStateToProps, mapDispatchToProps))(ActivatingId);
